import { useState } from "react";
import { Star, Send } from "lucide-react";
import { Button } from "../components/ui/button";
import { Textarea } from "../components/ui/textarea";
import axios from "axios";
import { API } from "../App";
import { toast } from "sonner";

const StarRating = ({ value, onChange, label }) => {
  const [hover, setHover] = useState(0);

  return (
    <div className="space-y-1.5">
      <p className="text-sm font-medium text-stone-700">{label}</p>
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            onClick={() => onChange(star)}
            onMouseEnter={() => setHover(star)}
            onMouseLeave={() => setHover(0)}
            className="p-0.5 transition-transform hover:scale-110"
          >
            <Star
              className={`w-7 h-7 transition-colors ${
                star <= (hover || value)
                  ? "fill-amber-400 text-amber-400"
                  : "fill-transparent text-stone-300"
              }`}
            />
          </button>
        ))}
      </div>
    </div>
  );
};

const FeedbackModal = ({ onClose }) => {
  const [comfort, setComfort] = useState(0);
  const [vsOld, setVsOld] = useState(0);
  const [denis, setDenis] = useState(0);
  const [notes, setNotes] = useState("");
  const [sending, setSending] = useState(false);

  const handleSubmit = async () => {
    if (!comfort || !vsOld || !denis) {
      toast.error("Per favore valuta tutte le categorie");
      return;
    }

    setSending(true);
    try {
      await axios.post(`${API}/feedback`, {
        comfort_rating: comfort,
        vs_old_rating: vsOld,
        denis_rating: denis,
        notes: notes.trim(),
      });
      await axios.post(`${API}/feedback/mark-done`);
      toast.success("Grazie per il tuo feedback!");
      onClose();
    } catch {
      toast.error("Errore nell'invio");
    } finally {
      setSending(false);
    }
  };

  const handleSkip = async () => {
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-5">
          <h2 className="font-outfit text-xl font-bold text-white">
            Il tuo parere conta!
          </h2>
          <p className="text-white/80 text-sm mt-1">
            Feedback anonimo sul nuovo End•ver
          </p>
        </div>

        {/* Content */}
        <div className="px-6 py-5 space-y-5">
          <StarRating
            label="Comodita' nell'utilizzo di End•ver"
            value={comfort}
            onChange={setComfort}
          />
          <StarRating
            label="Rispetto al vecchio passaggio consegne"
            value={vsOld}
            onChange={setVsOld}
          />
          <StarRating
            label="Quanto e' stato bravo Denis?"
            value={denis}
            onChange={setDenis}
          />

          <div className="space-y-1.5">
            <p className="text-sm font-medium text-stone-700">
              Note o miglioramenti da suggerire
            </p>
            <Textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Scrivi qui i tuoi suggerimenti (opzionale)..."
              rows={3}
              className="resize-none"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-stone-100 flex gap-3">
          <button
            onClick={handleSkip}
            className="text-sm text-stone-400 hover:text-stone-600"
          >
            Salta
          </button>
          <div className="flex-1" />
          <Button
            onClick={handleSubmit}
            disabled={sending}
            className="bg-stone-900 hover:bg-stone-800 rounded-xl px-6"
          >
            {sending ? (
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <>
                <Send className="w-4 h-4 mr-2" />
                Invia
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
